type IsPathActiveOptions = {
  basePath?: string;
  ignoreDrawNumber?: boolean;
};

/**
 * Function that determines if a given path should be considered as active.
 * It handles scenarios where it should be considered active only on path "/" and strips the basePath so we dont have to define it in MFE.
 *
 * @param currentPath the url/pathname that is active now (usePathname can be used)
 * @param activePaths the list of paths that the currentPath should be marked as active/selected on and return thus return true
 * @param options matching options
 * @param options.basePath the basePath of this tipsen game ie Powerplay (useBasePath can be used)
 * @param options.ignoreDrawNumber whether to ignore a numeric first path segment after the base path
 * @returns True if the currentPath should be considered active, false otherwise
 */
export function isPathActive(currentPath: string, activePaths: string[], options: IsPathActiveOptions = {}): boolean {
  const basePath = (options.basePath ?? '').replace(/\/$/, '');
  const isBasePathMatch = basePath === '' || currentPath === basePath || currentPath.startsWith(`${basePath}/`);
  const withoutBasePath = isBasePathMatch ? currentPath.slice(basePath.length) : currentPath;
  // Remove the complete numeric first path segment after the base path when ignoring draw number.
  const routePath = (options.ignoreDrawNumber ? withoutBasePath.replace(/^\/\d+(?=\/|$)/, '') : withoutBasePath) || '/';

  if (activePaths.includes('/') || activePaths.includes('')) {
    const isBasePath = routePath === '/';
    return (
      isBasePath ||
      activePaths
        .filter((path) => path !== '/' && path !== '')
        .some((path) => routePath.startsWith(path) || routePath.startsWith(`/${path}`))
    );
  }

  return activePaths.some((path) => routePath.startsWith(path) || routePath.startsWith(`/${path}`));
}
